import type { Property } from '../types';

export interface MapPanelFilters {
  search: string;
  types: Property['type'][];
  status: Property['status'][];
  priceMin?: number;
  priceMax?: number;
}

export const createEmptyMapPanelFilters = (): MapPanelFilters => ({
  search: '',
  types: [],
  status: [],
});

export const countActiveMapFilters = (filters: MapPanelFilters): number => {
  let count = 0;
  if (filters.search.trim()) count += 1;
  if (filters.types.length > 0) count += 1;
  if (filters.status.length > 0) count += 1;
  if (filters.priceMin != null || filters.priceMax != null) count += 1;
  return count;
};

/** Filtres avancés (hors recherche ville / nom). */
export const countAdvancedMapFilters = (filters: MapPanelFilters): number => {
  let count = 0;
  if (filters.types.length > 0) count += 1;
  if (filters.status.length > 0) count += 1;
  if (filters.priceMin != null || filters.priceMax != null) count += 1;
  return count;
};

export const clearAdvancedMapFilters = (
  filters: MapPanelFilters
): MapPanelFilters => ({
  ...filters,
  types: [],
  status: [],
  priceMin: undefined,
  priceMax: undefined,
});

export const filterPropertiesForMap = (
  properties: Property[],
  filters: MapPanelFilters
): Property[] => {
  const search = filters.search.trim().toLowerCase();

  return properties.filter((property) => {
    if (search) {
      const haystack = [
        property.title,
        property.description,
        property.location.city,
        property.location.postalCode,
        property.location.address,
      ]
        .join(' ')
        .toLowerCase();
      if (!haystack.includes(search)) return false;
    }

    if (filters.types.length > 0 && !filters.types.includes(property.type)) {
      return false;
    }

    if (filters.status.length > 0 && !filters.status.includes(property.status)) {
      return false;
    }

    if (filters.priceMin != null && property.price < filters.priceMin) {
      return false;
    }

    if (filters.priceMax != null && property.price > filters.priceMax) {
      return false;
    }

    return true;
  });
};
